/**
 * Created by renjie.huang on 2018/1/4.
 */


var _userinfo;

class userInfoService{

    constructor(){
        var self = this;
    }

     static getInstance(){
        if(!_userinfo){
            _userinfo = new userInfoService()
            return _userinfo;
        }else{
            return _userinfo;
        }
    }

     static getUrlEmail(hash){
         const start = hash.indexOf('email=');
         if (start !== -1){
            return hash.slice(start+6)
         }
         return ''
    }
}

export default userInfoService;


// WEBPACK FOOTER //
// src/service/userInfoService.js